import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ChooseRecipientsComponent } from '../../../users/components/choose-recipients/choose-recipients.component';
import { Subject, switchMap, withLatestFrom } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { Recipients } from 'src/app/models/recipients.model';

@Component({
    selector: 'que-save',
    imports: [CommonModule, ReactiveFormsModule, TranslateDirective, TranslatePipe, MatDialogModule, ChooseRecipientsComponent],
    templateUrl: './save.component.html',
    styleUrls: ['./save.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaveComponent {
  readonly requestOpenPopUp = new Subject<void>();

  #translate = inject(TranslateService)
  #questionnaireStore = inject(QuestionnaireStore)
  #dialog = inject(MatDialog);

  name$ = toSignal(this.#questionnaireStore.name$);
  isSendAll$ = toSignal(this.#questionnaireStore.isSendAll$);
  isUnauthorized$ = toSignal(this.#questionnaireStore.isUnauthorized$);
  isFilterField$ = toSignal(this.#questionnaireStore.filterFieldId$);
  isfilterFieldInUnauthorized$ = computed(() => (!this.isUnauthorized$()) || (this.isUnauthorized$() && !!this.isFilterField$())
  );

  // isChange$ = this.#questionnaireStore.isChangedd$;


  // isDisable$ = combineLatest([this.#questionnaireStore.isChangedd$, this.#questionnaireStore.isValid$, this.#questionnaireStore.category$]).pipe(map(
  //   ([isChange, isValid, category]) => {
  //     return isValid == false || category == undefined || isChange == false
  //   }
  // ));
  //isChange == false ||
  // isDisableSignal$ = toSignal(this.isDisable$)

  // id?: number;
  constructor() {
    // this.#activeRoutes.params.subscribe(
    //   p =>
    //     this.id = p['id']);
    this.requestOpenPopUp.pipe(
      withLatestFrom(this.#questionnaireStore.recipients$,
        this.#questionnaireStore.questionnaireId$,
        this.#questionnaireStore.mailForm$,
        this.#questionnaireStore.reminder$,
        this.#questionnaireStore.name$,
        this.#questionnaireStore.category$,
        this.#questionnaireStore.isSendAll$,

      ),
      switchMap(
        ([_, contact, id, mailForm, reminder, name, category, isSendAll]) => this.#dialog.open(ChooseRecipientsComponent,
          {
            data: { name: name, id: id, category, recipients: contact, mailForm: mailForm, isReminder: false, editReminder: reminder,isUnauthorized:this.isUnauthorized$(),isSendAll:isSendAll  },
            autoFocus: false,
            panelClass: 'dialog-panel'
          }).afterClosed()))
      .subscribe((result) => {
        if (result) {
          const [users, reminder, mailForm, event, isSendAll] = result;
          if ((users || mailForm) && event) {
            this.#questionnaireStore.saveDistributionDetails({ users: users as Recipients, mailForm, reminder ,isPublish:event == 'publish', isSendAll})
            // if (event == 'publish') {
            //   this.#questionnaireStore.publishWithContactAndMail({ users: users as Recipients, mailForm, reminder })
            // }
            // else {
            //   if (event == 'save') {
            //     this.#questionnaireStore.saveWithContactAndMail({ users: users as Recipients, mailForm, reminder, event })
            //   }
            // }
          }
        }

      })

    effect(() => {
      console.log('not remove , bug , the value not update ', this.isUnauthorized$());
    });

  }

  //   
  //   autoFocus: false,
  //   position: { top: '8%' },
  //   panelClass: 'dialog-panel'
  // }
  // ).afterClosed()
  // 
  // );
  openChooseRecipientsPopup() {
    this.requestOpenPopUp.next();

  }
}
